<template>
    <div class="your-comment">
        <form v-if="!loading" class="form">
            <field-wrapper :type="'textarea'" label="Ваш комментарий" @input="handleInput" v-model="message" @enter="handleEnter" :options="{focusOnMount:true}"></field-wrapper>
            <div class="btns-box">
                <span v-show="cancelBtn" class="js-cancel-comment" @click="cancelClick">Отменить</span>
                <button type="button" class="text-btn" :disabled="disabled" @click="handleClick">
                    <icon-base v-if="action===SEND_COMMENT" width="20" height="16" viewBox="0 0 20 16"><icon-mail/></icon-base>
                    {{action===SEND_COMMENT ? 'Отправить' : 'Сохранить'}}
                </button>
            </div>
        </form>
        <pre-loader-component :visible="loading" :small="true"></pre-loader-component>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import PreLoaderComponent from "../common/PreLoader";
    import FieldWrapper from "../common/fields/FieldWrapper";
    import IconBase from "../common/IconBase";
    import IconMail from "../common/icons/IconMail";
    import {SEND_COMMENT, EDIT_COMMENT} from "../../constants/common";

    export default {
        name: 'comment-form',
        components: {
            IconBase,
            IconMail,
            FieldWrapper,
            PreLoaderComponent
        },
        props: {
            post: Object,
            parent: {
                type: Number,
                default: 0
            },
            target: {
                type: Number,
                default: 0
            },
            cancelBtn: {
                type: Boolean,
                default: true
            },
            comment: Object,
            action: Number
        },
        data() {
            return {
                disabled: true,
                loading: false,
                message: '',
                SEND_COMMENT: SEND_COMMENT,
                EDIT_COMMENT: EDIT_COMMENT
            };
        },
        methods: {
            ...mapActions('knowledge',[
                'sendComment',
                'editComment'
            ]),
            handleInput(value) {
                this.message = value;
                this.disabled = !(value.length > 0)
            },
            handleClick() {
                this.sendMessage()
            },
            cancelClick() {
                this.message = '';
                this.$emit('cancel')
            },
            handleEnter(){
               this.sendMessage()
            },
            sendMessage() {
                if (this.action === SEND_COMMENT) {
                    this.loading = true;
                    this.sendComment({
                        msg: this.message,
                        parent: this.target,
                    }).then(() => {
                        this.loading = false;
                        this.message = '';
                        this.disabled = true;
                        this.$emit('cancel');

                    });
                } else {
                    this.loading = true;
                    this.editComment({
                        id: this.comment.id,
                        body: this.message,
                    }).then(() => {
                        this.loading = false;
                        this.message = '';
                        this.disabled = true;
                        this.$emit('cancel');
                    });
                }
            }
        },
        created() {
            if (this.comment && this.action === EDIT_COMMENT) {
                this.message = this.comment.text;
                if (this.message.length) {
                    this.disabled = false
                }
            }
        }
    }
</script>

<style scoped>

</style>
